/* ar-brown App (C) 2021 arbrown.co.jp All rights reserved.
 *******************************************************************************
 * Program ID:  Request.js
 * $Revision:   Ver1.0
 * $Modtime:    $
 *******************************************************************************
 * Author      (作成／更新年月日、担当者)
 *  2024/11/27 Rayoo)fu : 新規作成
 *
 * 請書マスタ一覧画面
 *
 * Instructions / Preconditions
 *  なし
 *
 *******************************************************************************
 */
import React, { useEffect, useState } from "react";
 /*  GraphQL API Acess */
import API, { graphqlOperation } from "@aws-amplify/api";
import { listArRequests } from "../graphql/queries";
 /*  AWS標準設定 with Login Auth. */
import Amplify ,{Auth}from "aws-amplify";
import awsconfig from "../aws-exports";
Amplify.configure(awsconfig);
import { Container,Col,InputGroup,Row } from "react-bootstrap";
import Grid from "@material-ui/core/Grid";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  fixedTop: {
    position: "sticky",
    top: 0,
    boxShadow: "0 -1px 0 0 white,0 3px 0 0 #804F29,0 3px 0 0 transparent",
    backgroundColor: "white",
    zIndex: 9,
  },
  textFieldSearch:{
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    background: "transparent",
    border: "1px solid #707070",
    borderRadius: "6px",
    color: "black",
    width:"80%"
  },
  textlabelSearch:{
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    background: "rgb(91,56,9)",
    border: "1px solid #707070",
    color: "white",
    fontWeight: "bold",
    fontSize: '14px',
    alignItems: 'center',
    justifyContent: 'center',
    width:"20%"
  }
}));
// 自定義のページネーション総数レンダリング
const customTotal = (from, to, size) => (
  <span style={{ marginLeft: "1em" }} className="react-bootstrap-table-pagination-total">
    {size} の結果の {from} から {to} を表示しています
  </span>
);

// 自定義のページボタンレンダリング
const pageButtonRenderer = ({ page, onPageChange }) => {
  const handleClick = (e) => {
    e.preventDefault();
    onPageChange(page);
  };
  return (
    <button className="btn-secondary btn" type="button" key={page}>
      <li className="page-item">
        <a style={{ color: "white" }} href="#" onClick={handleClick}>
          {page}
        </a>
      </li>
    </button>
  );
};

// ページサイズ選択ボタンのレンダリング
const sizePerPageRenderer = ({ options, currSizePerPage, onSizePerPageChange }) => (
  <div className="btn-group" role="group">
    {options.map((option) => (
      <button
        key={option.text}
        type="button"
        onClick={() => onSizePerPageChange(option.page)}
        className={`btn ${currSizePerPage === `${option.page}` ? "btn-warning" : "btn-light"}`}
      >
        {option.text}
      </button>
    ))}
  </div>
);

const options = {
  paginationSize: 10,
  pageStartIndex: 1,
  showTotal: true,
  withFirstAndLast: true,
  firstPageText: "最初",
  prePageText: "戻る",
  nextPageText: "次へ",
  lastPageText: "最後",
   nextPageTitle: "最初のページ",
   prePageTitle: "プレページ",
   firstPageTitle: "次のページ",
   lastPageTitle: "最後のページ",
  paginationTotalRenderer: customTotal,
  sizePerPageRenderer: sizePerPageRenderer,
  pageButtonRenderer: pageButtonRenderer,
  disablePageTitle: true,
  sizePerPageList: [
    { text: "10", value: 10 },
    { text: "20", value: 20 },
    { text: "30", value: 30 },
  ],
};

const Request = () => {
  const [reQuestList, setReQuestList] = useState([]);
  const [progress, setProgress] = useState(false);
  const classes = useStyles();
  const [UserNameList, setUserNameList] = useState([])
  const [AgencyIdList, setAgencyIdList] = useState([])
  const [AgencyEmailList, setAgencyEmailList] = useState([])
  const [TelList, setTelList] = useState([])
  const [searchValue, setSearchValue] = useState({
    Agency_id: "",
    User_Name: "",
    Agency_Email: "",
    Tel: "",
  })
  const searchAgencyIdChange = (e, value) => {
    setSearchValue({ ...searchValue, Agency_id: value ? value.split(":")[0] : "" })
  }
  const TextValueChange = (e, value,name) => {
    setSearchValue({ ...searchValue, [name]: value ? value : "" })
  }
  async function searchData() {
    let reQuestsInfoLIst = []
    let reQuestInfo = await API.graphql(
      graphqlOperation(listArRequests, { limit: 10000 })
    );
    if (reQuestInfo.data.listArRequests !== null) {
      reQuestsInfoLIst = reQuestInfo.data.listArRequests.items;
      let nextToken = reQuestInfo.data.listArRequests.nextToken;
      while (nextToken !== null) {
        let InvDataSec = await API.graphql(
          graphqlOperation(listArRequests, { limit: 10000, nextToken })
        );
        if (InvDataSec.data.listArRequests !== null) {
          nextToken = InvDataSec.data.listArRequests.nextToken;
          reQuestsInfoLIst.push(...InvDataSec.data.listArRequests.items);
        }
      }
    }
    return reQuestsInfoLIst
  }
  const searchBtn = async () => {
    setProgress(true)
    let arr = [];
    let obj = {};
    let dataAll = [];
    try {
      dataAll = await searchData()
      } catch (error) {
        console.log(error);
        }
        obj = searchValue;
        dataAll.forEach(item => {
          let flag = true
          if (Object.keys(obj).length !== 0) {
            for (let name in obj) {
              if (obj[name] !== "") {
                if (item[name]) {
                  if (!(item[name]).includes(obj[name])) {
                    flag = false;
                    break;
                  }
                } else {
                  flag = false
                  break;
                }
              }
            }
          }
          if (flag === true) {
            arr.push(item)
          }
        })
      arr = multiSort(arr,sortByAgency_Name)
      setReQuestList(arr);
      setProgress(false)
    }
  const searchClear = async()=>{
      setProgress(true)
      let arr = [];
      try {
        arr = await searchData()
        } catch (error) {
            if (error.message === 'No current user') {
                //ユーザープールに障害が発生した場合
                console.log('User pool is invalid.Please reauthenticate.');
                //ログイン画面に戻る
                signOut();
            } else {
                //他のエラーを処理する
                console.log('An error occurred:', error);
            }
        }
        arr = multiSort(arr,sortByAgency_Name)
        setSearchValue({ Agency_id: "",User_Name: "",Agency_Email: "",Tel: "",})
        setReQuestList(arr);
        setProgress(false)
    }
  const signOut = async () => {
    await Auth.signOut();
    try {
        await Auth.signOut();
    } catch (error) {
        console.log("error signing out: ", error);
    }
    document.location.reload();
  };
  const getTypePriority = (str) => {
    if (!str || str.trim() === "") return 99;
    const firstChar = str[0];
    if (/^[0-9]/.test(firstChar)) return 1;
    if (/^[a-zA-Z]/.test(firstChar)) return 2;
    if (/^[\u30A0-\u30FF]/.test(firstChar)) return 3;
    if (/^[\u3040-\u309F\u4E00-\u9FFF]/.test(firstChar)) return 4;
    return 5;
  };
  const sortByAgency_Name = (a, b) => {
    const nameA = a.Agency_Name || "";
    const nameB = b.Agency_Name || "";
    const priorityA = getTypePriority(nameA);
    const priorityB = getTypePriority(nameB);
    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }
    return nameA.localeCompare(nameB, 'ja', { sensitivity: 'base' });
  };
  const multiSort = (arr, ...sortFuncs)=> {
    return arr.sort((a, b) => {
      for (const func of sortFuncs) {
        const result = func(a, b);
        if (result !== 0) {
          return result;
        }
      }
      return 0;
    });
  }
  const [scrollTableWidth,setscrollTableWidth] = useState('101%')
  function calculateZoomLevel() {
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const zoomLevel = ((windowWidth / screenWidth) + (windowHeight / screenHeight)) / 2;
    return Math.round(zoomLevel * 100);
  }
  useEffect(() => {
    let isMounted = true; // コンポーネントがマウントされているか確認するためのフラグ
    let lastZoomLevel = calculateZoomLevel();
    async function getReQuestList() {
      setProgress(true); // データのロード開始
      try {
       let reQuestsInfoLIst = []
       let agencyIdList = []
       let userNameList = []
       let telList = []
       let agencyEmailList = []
        let reQuestInfo = await API.graphql(
          graphqlOperation(listArRequests, { limit: 10000 })
        );

        if (reQuestInfo.data.listArRequests !== null) {
          reQuestsInfoLIst = reQuestInfo.data.listArRequests.items;
          let nextToken = reQuestInfo.data.listArRequests.nextToken;

          // nextTokenがnullでない限り、データを追加で取得する
          while (nextToken !== null) {
            let InvDataSec = await API.graphql(
              graphqlOperation(listArRequests, { limit: 10000, nextToken })
            );
            if (InvDataSec.data.listArRequests !== null) {
              nextToken = InvDataSec.data.listArRequests.nextToken;
              reQuestsInfoLIst.push(...InvDataSec.data.listArRequests.items);
            }
          }
        }
        for (let i = 0; i < reQuestsInfoLIst.length; i++) {
          if (reQuestsInfoLIst[i].Agency_id) {
            agencyIdList.push(reQuestsInfoLIst[i].Agency_id + ":" + reQuestsInfoLIst[i].Agency_Name + " " + reQuestsInfoLIst[i].Company_Name)
            userNameList.push(reQuestsInfoLIst[i].User_Name)
            agencyEmailList.push(reQuestsInfoLIst[i].Agency_Email)
            telList.push(reQuestsInfoLIst[i].Tel)
          }
      }
        if (isMounted) {
          setUserNameList(Array.from(new Set(userNameList)))
          setAgencyIdList(Array.from(new Set(agencyIdList)))
          setTelList(Array.from(new Set(telList)))
          setAgencyEmailList(Array.from(new Set(agencyEmailList)))
          reQuestsInfoLIst = multiSort(reQuestsInfoLIst,sortByAgency_Name)
          setReQuestList(reQuestsInfoLIst); // コンポーネントがマウントされている場合、状態を更新
        }
        const handleResize = () => {
          let dom = document.querySelector("#table");
          const newZoomLevel = calculateZoomLevel();
          if (lastZoomLevel !== newZoomLevel) {
            if (newZoomLevel > lastZoomLevel) {
              setscrollTableWidth(dom ? `101%` : `101%`)
            }else {
              let width = dom ? (`${dom.offsetWidth}` < 1632 ? `1632px` : '101%') : '101%';
              setscrollTableWidth(`${width}`)
            }
            lastZoomLevel = newZoomLevel;
          }
        };
        window.addEventListener('resize',handleResize, 100);
        return () => window.removeEventListener('resize', handleResize);
      } catch (err) {
        console.error(err);
      } finally {
        if (isMounted) {
          setProgress(false); // ロードが終了したら進行状態を更新
        }
      }
    }

    getReQuestList();

    // クリーンアップ関数：コンポーネントがアンマウントされた場合、状態更新を防止
    return () => {
      isMounted = false;
    };
  }, []); // 空の依存配列なので、コンポーネントがマウントされたときに一度だけ実行
  const headerStyle = {
    backgroundColor: "white",
    borderBottom: "3px solid #B45210",
  };

  // 表示する列の設定
  const columns1 = [
    // { dataField: "id", text: "ID", hidden: true },
    { dataField: "Agency_id", text: "代理店コード", headerStyle, sort: true, style: {margin: "0px", width: "130px" } },
    { dataField: "Agency_Name", text: "代理店名", headerStyle, sort: true, style: {margin: "0px", width: "240px" } },
    { dataField: "Company_Name", text: "営業所名", headerStyle, sort: true, style: {margin: "0px", width: "240px" } },
    { dataField: "Agency_Email", text: "ユーザーメール", headerStyle, sort: true, style: {margin: "0px", width: "180px",minwidth: "180px" } },
    { dataField: "User_Name", text: "氏名", headerStyle, sort: true, style: {margin: "0px", width: "130px" } },
    { dataField: "Tel", text: "電話番号", headerStyle, sort: true, style: {margin: "0px", width: "130px" } },
    { dataField: "AssigneeCode", text: "担当者コード", hidden:  true,headerStyle, sort: true, style: {margin: "0px", width: "130px" } },
    { dataField: "Permission", text: "権限", hidden:  true,headerStyle, sort: true, style: {margin: "0px", width: "130px" } },
    { dataField: "SalesGroup", text: "所属営業Grp", hidden:  true,headerStyle, sort: true, style: {margin: "0px", width: "100px" } },
    { dataField: "UsageSystem", text: "使用システム",hidden:  true, headerStyle, sort: true, style: {margin: "0px", width: "100px" } },
    { dataField: "UsageCategory", text: "使用区分", hidden:  true,headerStyle, sort: true, style: {margin: "0px", width: "100px" } },
    { dataField: "Agency_Price_Group", text: "価格グループ", hidden:  true,headerStyle, sort: true, style: {margin: "0px", width: "130px" } },
  ];
  return (
    <Container
      style={{
        backgroundColor: "",
        minWidth: "100%",
        minHeight: "74vh",
        position: "relative", // CircularProgressの位置を親要素に対して相対的に設定
      }}
    ><Grid>
      <Grid>
      <Row
            style={{
              borderRadius: "0.25em",
              color: "purple",
              padding: "0.5em",
            }}
          >
      <div style={{ display: 'flex', marginBottom: "10px",width:"100%"}}>
      <Col>
        <h4
          style={{
            textAlign: "left",
              color: "black",
              height: 30,
              width: '20%',
              borderLeft: "4px solid #804F29",
              paddingLeft: "4px",
              whiteSpace:"nowrap"
          }}
        >
          請書マスタ
        </h4>
        </Col>
         <div style={{ width: '80%', height: 160 }}>
            <div style={{ width: '90%',minWidth:"500px",height: 160, border: '2px solid rgb(191,191,191)', display:'flex', flexWrap: "wrap",justifyContent:"center", padding: "30px 0px 0px 0px" }}>
               <div style={{ width: "50%", height: '25px' }}>
                   <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap", }}>
                     <InputGroup.Text
                         className={classes.textlabelSearch}
                         id="basic-name"
                         style={{ borderRadius: "0px",minWidth:"100px"}}
                     >代理店
                     </InputGroup.Text>
                       <Autocomplete
                        className={classes.textFieldSearch}
                        sx={{
                            display: 'inline-block',
                            '& input': {
                                height: 0,
                            },
                        }}
                        options={AgencyIdList}
                        value={searchValue.Agency_id}
                        name="Agency_id"
                        onChange={(e, value) => { searchAgencyIdChange(e, value) }}
                        renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                        isOptionEqualToValue={(option, value) => option.split(":")[0] === value || option === "" || value === ""}
                    />
                    </InputGroup>
               </div>
               <div style={{ width: "50%", height: '25px' }}>
                     <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap" }}>
                         <InputGroup.Text
                             className={classes.textlabelSearch}
                             id="basic-name"
                             style={{ borderRadius: "0px",minWidth:"100px"}}
                         >ユーザーメール
                         </InputGroup.Text>
                         <Autocomplete
                             className={classes.textFieldSearch}
                             sx={{
                               display: 'inline-block',
                               '& input': {
                                   height: 0,
                               },
                           }}
                             options={AgencyEmailList}
                             value={searchValue.Agency_Email}
                             maxLength ="20"
                             onChange={(e, value) => { TextValueChange(e, value,"Agency_Email") }}
                             name="Agency_Email"
                             id="Agency_Email"
                             isOptionEqualToValue={(option, value) => option === value || option === "" || value === ""}
                             renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                         />
                     </InputGroup>
               </div>
               <div style={{ width: "50%", height: '25px' }}>
                     <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap" }}>
                         <InputGroup.Text
                             className={classes.textlabelSearch}
                             id="basic-name"
                             style={{ borderRadius: "0px",minWidth:"100px"}}
                         >氏名
                         </InputGroup.Text>
                         <Autocomplete
                             className={classes.textFieldSearch}
                             sx={{
                               display: 'inline-block',
                               '& input': {
                                   height: 0,
                               },
                           }}
                             options={UserNameList}
                             value={searchValue.User_Name}
                             maxLength ="20"
                             onChange={(e, value) => { TextValueChange(e, value,"User_Name") }}
                             name="User_Name"
                             id="User_Name"
                             isOptionEqualToValue={(option, value) => option === value || option === "" || value === ""}
                             renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                         />
                     </InputGroup>
               </div>
               <div style={{ width: "50%", height: '25px' }}>
                     <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap" }}>
                         <InputGroup.Text
                             className={classes.textlabelSearch}
                             id="basic-name"
                             style={{ borderRadius: "0px",minWidth:"100px"}}
                         >電話番号
                         </InputGroup.Text>
                         <Autocomplete
                             className={classes.textFieldSearch}
                             sx={{
                               display: 'inline-block',
                               '& input': {
                                   height: 0,
                               },
                           }}
                             options={TelList}
                             value={searchValue.Tel}
                             maxLength ="20"
                             onChange={(e, value) => { TextValueChange(e, value,"Tel") }}
                             name="Tel"
                             id="Tel"
                             isOptionEqualToValue={(option, value) => option === value || option === "" || value === ""}
                             renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                         />
                     </InputGroup>
               </div>
               <div style={{margin:"auto"}}>
                 <Button className="btn" onClick={() => searchBtn()} style={{ height: 40, width: 120, fontSize: '16px', color: 'black', border: "3px solid black", background: "white",marginRight:'10px'}}>検索</Button>
                   <Button className="btn" onClick={() => searchClear()} style={{ height: 40, width: 120, fontSize: '16px', color: 'black', border: '3px solid black', background: "white"}}>Clear</Button>
               </div>
            </div>
           </div>
      </div>
      </Row>
       </Grid>
        <Grid>
        <div
            style={{
              width: "100%",
              height: "100%",
              overflowX: "scroll",
              transform: "scaleY(-1)",
            }}
          >
            <div
              style={{
                width: scrollTableWidth,
                height: "70vh",
                overflowY: "scroll",
                overflowX: "hidden",
                transform: "scaleY(-1)",
              }}
            >
              <div style={{ direction: "ltr" }}>
        <BootstrapTable
          id="table"
          striped={true}
          hover={true}
          wrapperClasses="boo bg-white"
          bootstrap4
          keyField="id"
          data={reQuestList}
          columns={columns1}
          noDataIndication={"no results found"}
          pagination={paginationFactory(options)}
          headerClasses={classes.fixedTop}
          />
        </div>
        </div>
        </div>
      </Grid>
      </Grid>
      {/* CircularProgress: ローディング状態を表示 */}
      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
        <CircularProgress
          size="3rem"
          disableShrink
          sx={{
            color: "#3f51b5",
            margin: "auto",
            display: progress ? "block" : "none",
            marginLeft: '60px',
          }}
        />
      </div>
    </Container>
  );
};

export default Request;
